import React from "react";

export default function AgentAvatar({ seed = "freelancity", size = 56, className = "" }) {
  const url = `https://api.dicebear.com/7.x/notionists/svg?seed=${encodeURIComponent(seed)}&backgroundColor=dbeafe,bfdbfe,e0f2fe,ffffff&radius=50`;
  return (
    <img
      src={url}
      alt={`Agent ${seed}`}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`rounded-full ring-2 ring-white shadow-[0_8px_24px_-12px_rgba(37,99,235,0.6)] bg-blue-50 ${className}`}
    />
  );
}
